import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

import Gallery from "../../../../../components/gallery/gallery.js";

import gstm1 from "../../../../../../assets/gstm1.jpg";
import gstm2 from "../../../../../../assets/gstm2.jpg";

export default function Gstm({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Ghost start time modifier" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="gstmPanel">
            <Trans i18nKey="gstmDetails" />

            <h2 className="text-center titles text-blue-400">{t("technologies")}</h2>

            <p className="text-center">Angelscript</p>

            <h2 className="text-center titles text-blue-400">{t("pictures")}</h2>

            <Gallery images={[gstm1,gstm2]}/>
        </Dialog>
    )
}